import PartnershipClientsPage from './PartnershipClientsPage';

export default PartnershipClientsPage;
